import { gql } from '@apollo/client'

export const BLOCK_HEIGHT = gql`{ blockHeight }`
